import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-8 sm:py-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            {/* Brand Column */}
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-3 sm:mb-4">
                <img
                  src="/logos/orangelabel-96.png"
                  alt="Orange Label"
                  className="h-7 sm:h-8 w-auto brightness-0 invert"
                />
                <span className="font-heading font-bold text-base sm:text-lg">Orange Label</span>
              </Link>
              <p className="text-xs sm:text-sm text-gray-300 mb-4 leading-relaxed">
                A global directory of businesses and meetups that accept and support Bitcoin payments.
              </p>
              
              {/* ABIB Section */}
              <div className="mt-4 pt-4 border-t border-gray-700">
                <a 
                  href="https://bitcoinindustrybody.org.au" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block mb-2"
                >
                  <img
                    src="/logos/abib-96.png"
                    alt="Australian Bitcoin Industry Body"
                    className="h-10 sm:h-12 w-auto brightness-0 invert"
                  />
                </a>
                <p className="text-[10px] sm:text-xs text-gray-400 leading-relaxed">
                  This website is maintained by the Australian Bitcoin Industry Body, in the advancement of Bitcoin in Australia.
                </p>
              </div>
            </div>
            
            {/* Quick Links - Matching Header Menu */}
            <div>
              <h3 className="font-heading font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Quick Links</h3>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/map" className="text-gray-300 hover:text-white transition-colors">
                    Map
                  </Link>
                </li>
                <li>
                  <Link to="/directory" className="text-gray-300 hover:text-white transition-colors">
                    Directory
                  </Link>
                </li>
                <li>
                  <Link to="/submit" className="text-gray-300 hover:text-white transition-colors">
                    Get Listed
                  </Link>
                </li>
                <li>
                  <Link to="/how-to-accept" className="text-gray-300 hover:text-white transition-colors">
                    Accept Bitcoin
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                    About
                  </Link>
                </li>
              </ul>
            </div>
            
            {/* Resources */}
            <div>
              <h3 className="font-heading font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Resources</h3>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li>
                  <a
                    href="https://btcmap.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors inline-flex items-center gap-1"
                  >
                    BTCMap.org
                    <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
                  </a>
                </li>
                <li>
                  <a 
                    href="https://bitcoinmerchants.com.au" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors inline-flex items-center gap-1"
                  >
                    Bitcoin Merchants
                    <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Connect */}
            <div>
              <h3 className="font-heading font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Connect</h3>
              <ul className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm">
                <li>
                  <a 
                    href="https://x.com/ausbtcindbody" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors inline-flex items-center gap-1"
                  >
                    @ausbtcindbody
                    <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
                  </a>
                </li>
                <li>
                  <a 
                    href="https://x.com/orangelabel_io" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors inline-flex items-center gap-1"
                  >
                    @orangelabel_io
                    <ExternalLink className="w-3 h-3" strokeWidth={1.5} />
                  </a>
                </li>
                <li>
                  <Link 
                    to="/contact"
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Disclaimer */}
        <div className="border-t border-gray-700 py-3 sm:py-4">
          <p className="text-[10px] sm:text-xs text-gray-400 text-center leading-relaxed px-4">
            Information provided on this website is not financial advice. Inclusion in this directory is not an endorsement 
            of any business, product, or service. Please conduct your own research before making any financial decisions.
          </p>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 py-4 sm:py-6">
          <div className="flex flex-col items-center gap-2 sm:gap-3">
            <p className="text-[10px] sm:text-xs text-gray-400">
              © {new Date().getFullYear()} Orange Label. All rights reserved.
            </p>
            <Link
              to="/privacy"
              className="text-[10px] sm:text-xs text-gray-400 hover:text-white transition-colors"
            >
              Privacy policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
